import _ from "lodash"
import moment from "moment"
import React from "react"
import { isMacOs, isMobile } from "react-device-detect"
//************************************//
import { API, _getAppLang, env } from '@utils'
//************************************//
export * from './SheetUtils'
//************************************//


export const uuidv4 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
//************************************//
export const getDuration = ({ fromDate, toDate }) => {
  fromDate = moment.utc(fromDate)
  toDate = toDate ? moment.utc(toDate) : moment.utc(Date.now())
  const out = moment.duration(fromDate.diff(toDate)).humanize(true)
  return out
}
//************************************//
export const replaceArrayOfStrings = (str, find, replace) => {
  let replaceString = str
  for (let i = 0; i < find.length; i++) {
    replaceString = replaceString.replaceAll(find[i], replace[i])
  }
  return replaceString
}
//************************************//
export const keyboardSymbol = (keys = '', splitKey = '|') => {
  if (isMobile) {
    return ''
  }

  keys = keys.toLowerCase()

  const baseFormats = {
    capslock: '⇪',
    shift: '⇧',
    up: '↑',
    right: '→',
    down: '↓',
    left: '←',
    enter: '↩',
    backspace: '⌫',
    delete: '⌦',
    escape: '⎋',
    tab: '⇥',
    pageup: '⇞',
    pagedown: '⇟',
    space: '␣'
  }

  const macFormats = {
    control: '⌃',
    ctrl: '⌃',
    alt: '⌥',
    option: '⌥',
    meta: '⌘',
    super: '⌘',
    cmd: '⌘',
    command: '⌘'
  }

  const winFormats = {
    control: 'ctrl',
    ctrl: 'ctrl',
    option: 'alt',
    alt: 'alt',
    meta: '❖',
    super: '❖',
    cmd: '❖',
    command: '❖'
  }

  const formats = isMacOs
    ? { ...baseFormats, ...macFormats }
    : { ...baseFormats, ...winFormats }

  return _.chain(keys)
    .split(splitKey)
    .map(x => (formats[x] ? formats[x] : x))
    .join('')
    .toUpper()
    .value()
}

export const callbackError = (err, setValErrors, callback = () => { }) => {
  if (err) {
    const arr = {}
    for (const f in err) {
      if (err[f] !== null) arr[f] = err[f][0]
    }
    setValErrors(arr)
    callback()
  }
}

export const componentSlots = (children) => {
  const slots = {}
  const childrenArray = _.isArray(children) ? children : [children]
  _.forEach(childrenArray, (child, index) => {
    if (typeof child === 'object' && typeof child.type === 'function') {
      if (child.props.slot) {
        slots[child.props.slot] = child
      }
    }
  })
  return slots
}

export const searchComponent = (children, component) => {
  let ChildComponent = <></>
  let exists = false

  React.Children.forEach(children, (child) => {
    if (child.type === component) {
      exists = true
      ChildComponent = child
    }
  })
  return { exists, component: ChildComponent }
}
//************************************//
export const _triggerDownloadableAnchorLink = (url, download = true) => {
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', download)
  document.body.appendChild(link)
  link.click()

  // Clean up and remove the link
  document.body.removeChild(link)
}
//************************************//
export const _downloadFile = (url, fileName = "No name") => {
  API.get(url, { responseType: 'blob' })
    .then((response) => {
      // Get the file name from the Content-Disposition header
      // const contentDisposition = response.headers['content-disposition']
      // let fileName = 'file' // Default file name
      // if (contentDisposition) {
      // 	const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
      // 	if (fileNameMatch && fileNameMatch[1]) {
      // 		fileName = fileNameMatch[1].replace(/['"]/g, '')
      // 	}
      // }

      const url = window.URL.createObjectURL(new Blob([response]))
      _triggerDownloadableAnchorLink(url, fileName)
    })
    .catch((error) => {
      console.error("Error:", error)
    })
}

export const knowledgeBaseUrl = (uri) => {
  if (_.startsWith(uri, "http")) {
    return uri
  } else if (_.startsWith(uri, "/")) {
    return `${env('REACT_APP_KNOWLEDGE_BASE_URL')}/${_getAppLang()}${uri}`
  } else {
    return `${env('REACT_APP_KNOWLEDGE_BASE_URL')}/${_getAppLang()}/${uri}`
  }
}

export const isValidUUID = (uuid) => {
  const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/
  return uuidRegex.test(uuid)
}

//*************** Debug helpers ***************//
const _getCallerFilePath = () => {
  const stack = new Error().stack
  if (!stack) return 'unknown'

  const lines = stack.split('\n')
  // Skip first 3 lines: Error creation, _getCallerFilePath, _logWithFileContext
  const relevantLines = lines.slice(3)

  for (const line of relevantLines) {
    // Chrome/Edge: "at functionName (path:line:col)" or "at path:line:col"
    let match = line.match(/\(([^)]+:\d+:\d+)\)/)
    if (match) {
      const fullPath = match[1].split(':').slice(0, -2).join(':')
      return fullPath.replace(/^(webpack-internal:\/\/\/|file:\/\/)/, '')
    }

    // Chrome/Edge without parentheses: "at path:line:col"
    match = line.match(/at\s+(.+:\d+:\d+)/)
    if (match) {
      const fullPath = match[1].split(':').slice(0, -2).join(':')
      return fullPath.replace(/^(webpack-internal:\/\/\/|file:\/\/)/, '')
    }

    // Firefox: "functionName@path:line:col" or "@path:line:col"
    match = line.match(/@(.+:\d+:\d+)/)
    if (match) {
      const fullPath = match[1].split(':').slice(0, -2).join(':')
      return fullPath.replace(/^(webpack-internal:\/\/\/|file:\/\/)/, '')
    }
  }

  return 'unknown'
}

// //*************** Debug helpers ***************//
// const _getCallerFilePath = () => {
//   const stack = new Error().stack
//   if (!stack) return { path: 'unknown', line: '' }

//   const lines = stack.split('\n')

//   for (const line of lines) {
//     // Skip lines from Utils.js itself and node_modules
//     if (line.includes('Utils.js') || line.includes('node_modules')) {
//       continue
//     }

//     // Chrome/Edge: "at functionName (path:line:col)" or "at path:line:col"
//     let match = line.match(/\(([^)]+):(\d+):\d+\)/)
//     if (match) {
//       const fullPath = match[1].replace(/^(webpack-internal:\/\/\/|file:\/\/)/, '')
//       return { path: fullPath, line: match[2] }
//     }

//     // Chrome/Edge without parentheses: "at path:line:col"
//     match = line.match(/at\s+(.+):(\d+):\d+/)
//     if (match) {
//       const fullPath = match[1].replace(/^(webpack-internal:\/\/\/|file:\/\/)/, '')
//       return { path: fullPath, line: match[2] }
//     }

//     // Firefox: "functionName@path:line:col" or "@path:line:col"
//     match = line.match(/@(.+):(\d+):\d+/)
//     if (match) {
//       const fullPath = match[1].replace(/^(webpack-internal:\/\/\/|file:\/\/)/, '')
//       return { path: fullPath, line: match[2] }
//     }
//   }

//   return { path: 'unknown', line: '' }
// }

/**
 * Console log with caller file context and shallow variable names.
 * Usage examples:
 *   _logWithFileContext(data) // logs variable 'data' with its name (prefered not to be object because it will extract it to keys)
 *   _logWithFileContext({data}) // This is preferable for objects to log key and object
 *   _logWithFileContext('something happened', { data1 }, { data2 })
 *   _logWithFileContext('error occurred', { error }, { level: 'error' })
 */
export const _logWithFileContext = (...args) => {
  try {
    const filePath = _getCallerFilePath()
    const parts = [...args]

    // Optional trailing options { level: 'log' | 'error' }
    let level = 'log'
    const maybeOptions = parts[parts.length - 1]
    if (maybeOptions && typeof maybeOptions === 'object' && !Array.isArray(maybeOptions) && (maybeOptions.level === 'log' || maybeOptions.level === 'error')) {
      level = maybeOptions.level
      parts.pop()
    }

    // Check log level - only allow errors when REACT_LOG_LEVEL !== 'info'
    const logLevel = env('REACT_APP_LOG_LEVEL')
    if (level === 'log' && logLevel !== 'info') {
      return // Suppress normal logs
    }

    const hasLabel = parts.length > 0 && typeof parts[0] === 'string'
    const label = hasLabel ? parts.shift() : null

    const prefix = label ? `[${filePath}] ${label}` : `[${filePath}]`
    const emit = level === 'error' ? console.error : console.log
    emit(prefix)

    if (!parts.length) return

    parts.forEach((arg, index) => {
      if (arg && typeof arg === 'object' && !Array.isArray(arg)) {
        const entries = Object.entries(arg)
        if (entries.length === 1) {
          const [key, val] = entries[0]
          emit(`${key}:`, val)
        } else {
          entries.forEach(([key, val]) => emit(`${key}:`, val))
        }
      } else {
        emit(`arg${index + 1}:`, arg)
      }
    })
  } catch (e) {
    console.error('[_logWithFileContext] Logging failed:', e)
  }
}
